import { forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';

export type UlProps = CommonHTMLAttributes & {
  children?: React.ReactNode;
};

const nakedUlStyles = css`
  list-style-type: none;
  padding-left: 0;
`;

export const NakedUl = forwardRef<HTMLUListElement, UlProps>(({ children, className, ...rest }, ref) => (
  <ul className={cx(nakedUlStyles, className)} {...rest} ref={ref}>
    {children}
  </ul>
));
NakedUl.displayName = 'NakedUl';
